<template>
  <div class="currencyInput">
    <label v-if="label || helperText" for="money">
      <strong v-if="label">{{ label }}</strong>
      <span v-if="helperText" class="helperText">{{ helperText }}</span>
    </label>
    <div class="inputWrapper">
      <input
        id="money"
        :value="displayValue"
        class="money-input"
        type="text"
        inputmode="decimal"
        @input="handleInput"
        @blur="handleBlur"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from "vue";

const props = defineProps({
  helperText: {
    type: String,
    default: ""
  },
  label: {
    type: String,
    default: ""
  },
  name: {
    type: String,
    default: ""
  },
  type: {
    type: String,
    default: ""
  },
  value: {
    type: [Number, String],
    default: ""
  },
  placeholder: {
    type: String,
    default: ""
  }
});

const emit = defineEmits(["input"]);

const localValue = ref("");

function formatCurrency(val: number) {
  return "$" + Number(val).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const displayValue = computed(() => {
  if (localValue.value !== "") return localValue.value;
  if (props.value == null || props.value === "") return "";
  return formatCurrency(Number(props.value));
});

function handleInput(e: Event) {
  localValue.value = (e.target as HTMLInputElement).value;
}

function handleBlur() {
  const raw = localValue.value.replace(/[^0-9.]/g, "");
  const num = parseFloat(raw);
  if (!isNaN(num)) {
    emit("input", num);
  }
  localValue.value = "";
}
</script>

<style scoped lang="scss">
input {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  line-height: 20px;
  padding: 8px 0 8px;
  max-width: 100%;
  min-width: 0px;
  width: 100%;
  outline: none;
}
label {
  display: block;
  margin-bottom: 3px;
  .title {
    font-weight: bold;
  }
  > * {
    display: block;
  }
}
.helperText {
  font-size: 0.8rem;
}
.inputWrapper {
  display: flex;
  padding: 0 12px;
  background: #ffffff;
  border: 1px solid #ddd;
  border-radius: 3px;
}
</style>
